import LoginStore from '../../../services/session/LoginStore';
import SessionStore from '../../../services/session/SessionStore';
import GenerateTasks from '../../../modules/workflow/task/systemTasks/GenerateTasks';
import presignedExport from '../../../services/auth/presignedExport';

(function () {
  'use strict';
  const mod = angular.module('clientDashboardApp.admin.users', [
    'clientDashboardApp.admin.users.userManagerService',
    'clientDashboardApp.admin.users.locations.userLocationsEditor'
  ]);
  mod.value('GenerateTasks', GenerateTasks);
  mod.controller("UserManagerCtrl", UserManagerCtrl);

  UserManagerCtrl.$inject = ['$scope','$q', '$state', '$location', 'accountId', 'userService', 'userManagerService', 'updateService', 'adminSearchService', 'stringService', 'configService'];
  function UserManagerCtrl($scope, $q, $state, $location, accountId, userService, userManagerService, updateService, adminSearchService, stringService, configService) {

    var vm = this;
    vm.userSearchQuery = adminSearchService.getSearchQuery();
    vm.freshQuery = null;
    vm.accountSelected = false;
    vm.totalUsersInResponse = null;
    vm.state = {
      loading : true,
      updating: false
    }
    vm.userExportConfig = {};
    vm.usertoLocationExportConfig = {};

    vm.pageStrings = stringService.adminStrings();
    vm.updateDetails = updateService.getUpdateDetails();

    vm.accountConfig = {
      required : false,
      accountId : null,
      disableDropdown: false,
      showAccountSelection: true
    }

    vm.updateConfig = {
      entityId : null,
      pageOneResult : true
    }

    vm.systemTask = {
      isOpen: false,
      user: undefined,
      onExit: () => {}
    };

    userService.currentUser().then(function(user){
      vm.currentUser = user;
      vm.canCreateSSOToken = vm.currentUser.permissions.indexOf('CreateSingleSignOnToken') >= 0;
    });

    vm.camelCaseToSpaces = str => str.replace(/([A-Z])/g, " $1").trim();

    vm.findUserType = function (user) {
      return _.findWhere(vm.userTypes, {id: user.userType});
    };

    vm.isLocationAdminUser = function (user) {
      // TODO - remove isLocationAdminUser and isGroupAdminUser,
      // and just disable entries in the UI that are inherited from some other entity
      return user.permissions.indexOf("AccessToOwnAccount") > -1

    };

    vm.isGroupAdminUser = function (user) {
      return user.permissions.indexOf("AccessToOwnAccount") > -1
    };

    vm.openConfirmDeleteUserModal = function (user) {
      vm.user = angular.copy(user);
      $('#confirmDeleteUserModal').modal();
    };

    vm.workflowEnabled = false;
    configService.getBrandConfig(false, false).then(brandConfig => {
      vm.workflowEnabled = !brandConfig.restrictions.hideWorkflow2;
    })

    vm.usersPaged = {
      users: [],// response.users.users,
      total: 0, // response.users.total,
      pageSize: 30,
      currentPageNum: 1
    };

    function getOffset() {
      return (vm.usersPaged.currentPageNum - 1) * vm.usersPaged.pageSize;
    }

    let currentRequestId = 0
    vm.refreshUsers = function (searchQuery) {
      vm.state.loading = true;
      vm.userSearchQuery = adminSearchService.getSearchQuery();
      vm.freshQuery = vm.userSearchQuery;
      var accountIdToPass = vm.accountConfig.accountId == "all" ? undefined : vm.accountConfig.accountId;

      var dataLoad = {};
      dataLoad.users = userManagerService.listUsers(accountIdToPass,vm.userSearchQuery, getOffset(), vm.usersPaged.pageSize);
      dataLoad.userTypes = userManagerService.userTypes();
      const requestId = ++currentRequestId;
      $q.all(dataLoad).then(function (response) {
          if (currentRequestId !== requestId) {
            return
          }
          vm.state.loading = false;
          vm.userTypes = response.userTypes.data.userTypes;
          vm.usersPaged.users = response.users.users;
          vm.usersPaged.totalResults = response.users.total;

          if(vm.updateConfig.entityId){
            if(_.where(vm.usersPaged.pagedItems[0],{id:vm.updateConfig.entityId}).length>0){
              vm.updateConfig.pageOneResult = true;
            }
          }
          });
    };

    vm.userExportConfig = (type) => {
      var accountIdToPass = vm.accountConfig.accountId == "all" ? undefined : vm.accountConfig.accountId
      if(vm.exportingUsers) return;
      vm.exportingUsers = true;
      if (type == "Users")
        presignedExport.downloadExport('/v5/export/users', {accountId: accountIdToPass, userSearchQuery: vm.userSearchQuery}).then((resp) => {
          vm.exportingUsers = false;
          return resp;
        });
      if (type == "UsersToLocations")
        presignedExport.downloadExport('/v5/export/usersToLocations', {accountId: accountIdToPass, userSearchQuery: vm.userSearchQuery}).then((resp) => {
          vm.exportingUsers = false;
          return resp;
      });
    };

    vm.updatePagingState = function(){
      vm.refreshUsers();
    };

    vm.updateUser = function (user) {
      userManagerService.updateUser(user).then(function () {
        vm.refreshUsers();
      });
    };

    vm.deleteUser = function (user) {
      vm.state.updating = true;
      userManagerService.deleteUser(user).then(function () {
        var updateInfo = {
          status: "Active",
          type: "user",
          title: "User",
          destinationRole: "manage",
          notificationType: "detail",
          actions: [{action:"delete"}],
          entity: vm.user,
          id: vm.user.id,
          name: vm.user.username,
          searchParam: vm.user.username
        }
        updateService.registerSuccessfulUpdate(updateInfo);
        $state.reload();
      },function(){
        vm.state.updating = false;
      });
    };

    vm.openNewTabAsUser = function (user) {
      SessionStore.impersonateUser(user.username);
    };

    vm.gotoUserEditor = function(opType,user) {

      if(opType=="create"){
        $location.path("admin/v2/users/create");
      }
      else if(opType=="edit"){
        $location.path("admin/v2/users/"+user.id+"/edit");
      }
    }

    vm.isUpdatedItemRow = function(id,entityId){
      return id==entityId;
    }

    vm.showSystemTasks = function(user) {
      vm.systemTask = {
        user: user,
        isOpen: true,
        onExit: vm.closeSystemTask
      }
    }

    vm.closeSystemTask = function() {
      vm.systemTask = {
        isOpen: false
      }
    }

    $scope.$watch('vm.accountConfig.accountId',function(newVal,oldVal) {
      if(oldVal !== newVal) {
        vm.refreshUsers();
      }
    });

  }
})();
